// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3wH0M","buttons":"RemoveExpirationActionButtons_buttons__rUGSd"};